<template>
    

    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        

        <!-- SIDEBAR -->
        <SidebarBody/>

        

        <div class="hp-main-layout">

            <!-- HEADER -->
            <HeaderBody/>
            
            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content" >

                <div class="row mb-32 gy-32 dash-top">

                    <div class="col-12">

                        
                        <div class="row g-32">

                            

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -70px;"></h2>
                                
                                

                                <div class="row g-32">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-body">
                                                <h3 style="text-align: center;" class="mm-none">Connect Socials</h3>
                                                <p class="hp-p1-body mm-none" style="text-align: center;">Connect your socials for a more seamless FanBayz experience</p>

                                                <p class="hp-p1-body dd-none" >Connect your socials for a more seamless FanBayz experience</p>

                                                <div class="mm-none">
                                                    <div class="divider mt-18 mb-16 "></div>
                                                </div>

                                                <div class="dd-none">
                                                    <div class="divider mt-18  "></div>
                                                </div>

                                                <div class="row g-32" style="margin-top: 30px;">

                                                    <div class="col-12 col-xl-6">

                                                        <button type="button" class="btn py-24 w-100">
                                                            <img src="@/assets/img/google.png" alt="" style="width: 40px; ">
                                                            <span class="hp-p1-body" style="margin-left: 20px;">Connect Google Account</span>
                                                        </button>

                                                    </div>

                                                    <div class="col-12 col-xl-6">

                                                        <button type="button" class="btn py-24 w-100" >
                                                            <img src="@/assets/img/facebook.png" alt="" style="width: 40px;">
                                                            <span class="hp-p1-body" style="margin-left: 20px;">Connect Facebook Account</span>
                                                        </button>

                                                    </div>

                                                    <div class="col-12 col-xl-6">

                                                        <button type="button" class="btn py-24 w-100" >
                                                            <img src="@/assets/img/twitter.png" alt="" style="width: 40px;">
                                                            <span class="hp-p1-body" style="margin-left: 20px;">Connect Twitter Account</span>
                                                        </button>

                                                    </div>

                                                </div>

                                                

                                                

                                                

                                                

                                                
                                                
                                                <div class="divider mt-18 mb-16"></div>

                                                
                                                <div class="mb-24" style="margin-top: 550px;">

                                                        

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SETTINGS -->
                            <SettingsBody/>
                            

                        </div>

                    </div>

                    
                </div>

                 <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

    <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

</template>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import SettingsBody from '@/components/SettingsBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc } from "firebase/firestore"; 
    import {getAuth, signInWithPopup, GoogleAuthProvider, FacebookAuthProvider} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            SettingsBody,
            HeaderBody,
            FooterBody,
        },

        data(){
            return{

                loadingText:"",
                errorText: "",
                successText: "",

            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Connect Socials';

            
            document.getElementById("moreN").classList.add("active");
            document.getElementById("moreN2").classList.add("active");

        },

        methods:{

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            connectGoogle(){

                this.loadingText = "Connecting google account...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();
                const provider = new GoogleAuthProvider();

                signInWithPopup(auth, provider)
                .then((result) => {
                    // This gives you a Google Access Token. You can use it to access the Google API.
                    const credential = GoogleAuthProvider.credentialFromResult(result);
                    const token = credential.accessToken;
                    // The signed-in user info.
                    const user = result.user;
                    console.log(result);
                    // IdP data available using getAdditionalUserInfo(result)
                    this.$refs.loadingModal.classList.remove("bg-active");
                    // ...
                }).catch((error) => {
                    // Handle Errors here.
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    // The email of the user's account used.
                    const email = error.customData.email;
                    // The AuthCredential type that was used.
                    const credential = GoogleAuthProvider.credentialFromError(error);

                    this.errorText = "An error occured. Connection request failed. Please ensure that your network connection is stable. "+errorMessage;
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                    // ...
                });

            },

            connectFacebook(){

            },

        },
        
    }
</script>